import { z } from 'zod';

import { INVOICE_FILE_TYPES } from './constants';

export const zodInvoiceFileEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.uuid(),
  z.literal('file'),
]);

export const zodInvoiceFileSearchParamsSchema = z.object({
  fileType: z.enum(INVOICE_FILE_TYPES),
});

export const zodInvoiceFileParamsSchema = z.object({
  fileType: z.enum(INVOICE_FILE_TYPES),
  invoiceId: z.uuid(),
});
